const mostVisitedZonesSlug = {
  BOLOGNA: [
    'it/bologna/san-donato-pilastro',
    'it/bologna/murri-massarenti',
    'it/bologna/toscana-savena',
    'it/bologna/san-vitale-mazzini',
    'it/bologna/costa-saragozza-saffi',
  ],
  FLORENCE: [
    'it/firenze/centro',
    'it/firenze/campo-di-marte-liberta',
    'it/firenze/coverciano-bellariva',
    'it/firenze/oltrarno',
    'it/firenze/michelangelo-porta-romana',
  ],
  MILAN: [
    'it/milano/centro',
    'it/milano/fiera-sempione-city-life-portello',
    'it/milano/porta-romana-cadore-montenero',
    'it/milano/citta-studi-susa',
    'it/milano/porta-venezia-indipendenza',
  ],
  ROME: [
    'it/roma/salario-trieste',
    'it/roma/prati-borgo-mazzini-delle-vittorie',
    'it/roma/parioli-flaminio',
    'it/roma/centro-storico',
    'it/roma/bologna-policlinico',
  ],
  TURIN: [
    'it/torino/centro',
    'it/torino/crocetta-san-secondo',
    'it/torino/campidoglio-san-donato-cit-turin',
    'it/torino/borgo-san-paolo-cenisia',
    'it/torino/santa-rita-mirafiori-nord',
  ],
  VERONA: [
    'it/verona/borgo-nuovo-navigatori-ponte-crencano',
    'it/verona/borgo-roma-ca-di-david',
    'it/verona/borgo-venezia-santa-croce-porto-san-pancrazio',
    'it/verona/borgo-milano-stadio-san-massimo-croce-bianca',
    'it/verona/centro',
  ],
}

export default mostVisitedZonesSlug
